"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.implCOMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP = exports.COMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP = void 0;
var dbLoadFlightStatisticPrices_1 = require("../db/dbLoadFlightStatisticPrices");
var consoleStringify_1 = require("../../../../utils/env/consoleStringify");
exports.COMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP = "COMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP";
var implCOMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP = function (_a) {
    var db = _a.db;
    return ({
        executionTimeout: 30000,
        execute: function (_a) {
            var message = _a.message, reply = _a.reply, next = _a.next;
            return __awaiter(void 0, void 0, void 0, function () {
                var _b, updatedAfterTimestamp, origin, destination, depart, roundTrip, loadMonths, prices, e_1, error;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!message.dynaNodeInfo.isForwardedFromMaster) {
                                next();
                                console.error('message.dynaNodeInfo.isForwardedFromMaster error', consoleStringify_1.consoleStringify(message));
                                return [2 /*return*/];
                            }
                            _b = message.args, updatedAfterTimestamp = _b.updatedAfterTimestamp, origin = _b.origin, destination = _b.destination, depart = _b.depart, roundTrip = _b.roundTrip, loadMonths = _b.loadMonths;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, dbLoadFlightStatisticPrices_1.dbLoadMonthlyBCFP(db, {
                                    updatedAfterTimestamp: updatedAfterTimestamp,
                                    origin: origin,
                                    destination: destination,
                                    depart: depart,
                                    roundTrip: roundTrip,
                                    loadMonths: loadMonths,
                                })];
                        case 2:
                            prices = _c.sent();
                            reply({
                                command: 'response',
                                data: {
                                    prices: prices,
                                },
                            })
                                .catch(function () { return undefined; });
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _c.sent();
                            error = {
                                code: 1909221530,
                                section: exports.COMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP,
                                message: 'Cannot ask database',
                            };
                            reply({
                                command: 'error/500',
                                data: error,
                            })
                                .catch(function () { return undefined; });
                            console.error('Cannot read database', consoleStringify_1.consoleStringify({ iError: error, actualError: e_1 }));
                            return [3 /*break*/, 4];
                        case 4:
                            next();
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
};
exports.implCOMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP = implCOMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP;
//# sourceMappingURL=COMMAND_FPS_LOAD_FLIGHT_MONTHLY_BCFP.js.map